module.exports = __webpack_public_path__ + "img/icm-academy-november.ba8523a0.png";